(function () {
  'use strict';
  if (window.KpUtsavJourney) return;

  const storageKey = 'kpUtsavJourneyReturnV1';
  const groupId = 'kp-utsav-combo-v1';
  let observedOwnLines = Boolean(document.querySelector('script[data-kp-utsav-owned="true"]'));
  let cartRevision = 0;
  let pendingMutations = 0;
  let lastActive = null;
  const sourceElement = document.querySelector('script[data-kp-utsav-money-format]');
  const preciseMoneyFormat = sourceElement?.dataset.kpUtsavMoneyFormat;
  let lastCartSubtotal = sourceElement?.dataset.kpUtsavCartSubtotal;
  let originalMoneyFormat;
  let moneyFormatOwner;
  const subtotalLabels = new Map();
  const params = () => new URLSearchParams(window.location.search);
  const isOwnLine = (line) => String(line?.properties?._combo) === 'true'
    && String(line?.properties?._combo_group || '') === groupId;
  const isActive = () => Boolean(document.querySelector('.combo-page--utsav'))
    || params().get('kp_utsav') === '1' || observedOwnLines;
  const legacyBuilderPaths = new Set([
    '/pages/combo-page', '/pages/everyday-combos', '/pages/ootd-combos',
    '/pages/trending-combos', '/pages/top-earrings-combos', '/pages/festive-combo-page'
  ]);

  const safeBuilderUrl = (value) => {
    if (!value) return null;
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || url.username || url.password) return null;
      if (url.searchParams.getAll('view').length > 1) return null;
      if (legacyBuilderPaths.has(url.pathname) && !url.searchParams.has('view')) return url.pathname;
      if (url.pathname !== '/pages/utsav-combo'
        && !(url.pathname === '/pages' && url.searchParams.get('view') === 'utsav-combo')) return null;
      if (url.pathname === '/pages/utsav-combo' && url.searchParams.has('view')
        && url.searchParams.get('view') !== 'utsav-combo') return null;
      return '/pages/utsav-combo';
    } catch (error) { return null; }
  };

  const readReturn = () => {
    try { return safeBuilderUrl(window.sessionStorage.getItem(storageKey)); } catch (error) { return null; }
  };
  const builderUrl = () => {
    const current = document.querySelector('.combo-page--utsav') ? safeBuilderUrl(window.location.href) : null;
    const fallback = safeBuilderUrl(document.querySelector('script[data-kp-utsav-builder-url]')?.dataset.kpUtsavBuilderUrl);
    return current || safeBuilderUrl(params().get('kp_utsav_return')) || readReturn() || fallback || '/pages/utsav-combo';
  };
  const notify = () => {
    refreshHeader();
    refreshMoney();
    const active = isActive();
    if (active === lastActive) return;
    lastActive = active;
    document.dispatchEvent(new CustomEvent('kp:utsav-journey-change', { detail: { active } }));
  };
  const observeCart = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return;
    observedOwnLines = cart.items.some(isOwnLine);
    if (Number.isSafeInteger(cart.total_price) && cart.total_price >= 0) lastCartSubtotal = cart.total_price;
    notify();
  };
  const productUrl = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || url.username || url.password || !url.pathname.startsWith('/products/')) return '#';
      url.searchParams.set('kp_utsav', '1');
      url.searchParams.set('kp_utsav_return', builderUrl());
      return url.pathname + url.search + url.hash;
    } catch (error) { return '#'; }
  };

  let offerInFlight = null;
  const offerError = (message, code) => Object.assign(new Error(message), { code });
  const offerUnavailable = () => offerError('Your Utsav offer is not available right now. Your selection is saved. Please try again later.', 'OFFER_UNAVAILABLE');
  const cartChanged = () => offerError('Your selection changed while the offer was being checked. Please review it and try again.', 'CART_CHANGED');
  const cartSignature = (cart) => {
    const groups = new Map();
    (cart?.items || []).forEach(item => {
      const identity = JSON.stringify([String(item.variant_id || item.id || item.handle || ''),
        String(item.selling_plan_allocation?.selling_plan?.id || ''),
        Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b))]);
      const value = groups.get(identity) || [0, 0, 0, []];
      value[0] += Number(item.quantity || 0);
      value[1] += Number(item.original_line_price ?? item.line_price ?? 0);
      value[2] += Number(item.final_line_price ?? item.line_price ?? 0);
      (item.line_level_discount_allocations || []).forEach(allocation => {
        value[3].push([String(allocation.discount_application?.title || ''), Number(allocation.amount || 0)]);
      });
      groups.set(identity, value);
    });
    const lines = Array.from(groups).sort(([a], [b]) => a.localeCompare(b));
    lines.forEach(([, value]) => value[3].sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b))));
    const codes = (cart?.discount_codes || []).map(entry => typeof entry === 'string'
      ? [entry, null] : [String(entry?.code || ''), entry?.applicable ?? null])
      .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
    const orderDiscounts = (cart?.cart_level_discount_applications || []).map(entry => [
      String(entry.title || ''), String(entry.type || ''), Number(entry.total_allocated_amount || 0)
    ]).sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
    return JSON.stringify([cart?.currency || '', Number(cart?.total_price || 0), Number(cart?.total_discount || 0), codes, orderDiscounts, lines]);
  };
  // Read the same collection used by the Shopify discount, rather than inferring
  // eligibility from the page where a piece was added or from its title.
  const eligibilityCache = new Map();
  const membershipFor = (item) => {
    const handle = String(item?.handle || '');
    const productId = String(item?.product_id || '');
    if (!handle || !productId) return Promise.reject(offerUnavailable());
    const cacheKey = `${handle}:${productId}`;
    const cached = eligibilityCache.get(cacheKey);
    if (cached && cached.expires > Date.now()) return cached.promise;
    const promise = (async () => {
      const root = window.Shopify?.routes?.root || '/';
      const url = new URL(`${root}products/${encodeURIComponent(handle)}`, window.location.origin);
      url.searchParams.set('section_id', 'kp-utsav-eligibility');
      const preview = params().get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(url.toString(), { cache: 'no-store', credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw offerUnavailable();
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const marker = document.querySelector('[data-kp-eligibility-product-id][data-kp-eligibility]');
        if (!marker || marker.dataset.kpEligibilityProductId !== productId
          || !['true', 'false'].includes(marker.dataset.kpEligibility)) throw offerUnavailable();
        return marker.dataset.kpEligibility === 'true';
      } finally { window.clearTimeout(timeout); }
    })();
    eligibilityCache.set(cacheKey, { promise, expires: Date.now() + 60000 });
    promise.catch(() => { if (eligibilityCache.get(cacheKey)?.promise === promise) eligibilityCache.delete(cacheKey); });
    return promise;
  };
  const resolveEligibleItems = async (cart) => {
    if (!Array.isArray(cart?.items)) throw offerUnavailable();
    const results = await Promise.all(cart.items.map(async item => {
      const excluded = ['_combo_excluded', '_gift_wrap', '_rakhi_addon']
        .some(key => String(item?.properties?.[key]) === 'true');
      if (excluded || ['rakhi-giftbox', 'gift-wrap'].includes(item?.handle)
        || Number(item?.original_line_price ?? item?.line_price ?? 0) <= 0) return false;
      return membershipFor(item);
    }));
    return cart.items.filter((item, index) => results[index]);
  };
  const evaluateEligibility = async (cart) => {
    const items = await resolveEligibleItems(cart);
    const units = items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    const subtotal = items.reduce((sum, item) => sum + Number(item.original_line_price ?? item.line_price ?? 0), 0);
    if (!Number.isSafeInteger(units) || units < 0 || !Number.isSafeInteger(subtotal) || subtotal < 0) throw offerUnavailable();
    return { items, units, subtotal, qualifies: units > 0 && subtotal >= 699900 };
  };
  const requestOfferCart = async () => {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 12000);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        method: 'GET', cache: 'no-store', credentials: 'same-origin', signal: controller.signal,
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw offerUnavailable();
      const cart = await response.json();
      if (!cart || !Array.isArray(cart.items)) throw offerUnavailable();
      return cart;
    } finally { window.clearTimeout(timeout); }
  };
  const eligibleOfferItems = async (cart, resolveEligibleItems) => {
    const items = await resolveEligibleItems(cart);
    if (!Array.isArray(items)) throw offerUnavailable();
    const eligible = items;
    const units = eligible.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    const subtotal = eligible.reduce((sum, item) => sum + Number(item.original_line_price ?? item.line_price ?? 0), 0);
    if (!eligible.length || !Number.isSafeInteger(units) || units < 1
      || !Number.isSafeInteger(subtotal) || subtotal < 699900) {
      throw offerError('Choose eligible products worth ₹6,999 or more before discount.', 'NOT_QUALIFIED');
    }
    return eligible;
  };
  const hasOfferAllocations = (items) => Array.isArray(items) && items.length > 0 && items.every(item => {
    const original = Number(item.original_line_price ?? item.line_price ?? 0);
    const savings = (item.line_level_discount_allocations || [])
      .filter(allocation => ['UTSAV20', 'Utsav Offer'].includes(allocation.discount_application?.title))
      .reduce((sum, allocation) => sum + Number(allocation.amount || 0), 0);
    return Number.isSafeInteger(original) && original > 0 && Number.isSafeInteger(savings)
      && savings >= Math.floor(original / 5) && savings <= Math.ceil(original / 5);
  });
  // Shopify owns discount selection. Never rewrite a shopper's codes from the
  // theme: doing so can race a code entered in another tab. This only verifies
  // the automatic offer on a fresh, unchanged cart.
  const ensureOfferDiscount = (cart, resolver) => {
    if (typeof resolver !== 'function' || !Array.isArray(cart?.items)) {
      return Promise.reject(offerUnavailable());
    }
    const signature = cartSignature(cart);
    if (offerInFlight) {
      if (offerInFlight.signature !== signature) return Promise.reject(cartChanged());
      return offerInFlight.promise;
    }
    const operation = async () => {
      const revision = cartRevision;
      if (pendingMutations) throw cartChanged();
      const fresh = await requestOfferCart();
      if (pendingMutations || cartRevision !== revision || cartSignature(fresh) !== signature) throw cartChanged();
      const eligible = await eligibleOfferItems(fresh, resolver);
      if (pendingMutations || cartRevision !== revision) throw cartChanged();
      if (!hasOfferAllocations(eligible)) throw offerUnavailable();
      return { cart: fresh, revision };
    };
    const promise = operation();
    offerInFlight = { signature, promise };
    promise.finally(() => { if (offerInFlight?.promise === promise) offerInFlight = null; }).catch(() => {});
    return promise;
  };

  const headerText = new Map();
  const headerAttributes = new Map();
  const refreshMoney = () => {
    if (!isActive()) {
      if (moneyFormatOwner && window.theme === moneyFormatOwner && window.theme.moneyFormat === preciseMoneyFormat) window.theme.moneyFormat = originalMoneyFormat;
      moneyFormatOwner = null;
      subtotalLabels.forEach((value, node) => { if (node.textContent === 'Subtotal: ') node.textContent = value; });
      subtotalLabels.clear();
      return;
    }
    if (window.theme && typeof preciseMoneyFormat === 'string' && preciseMoneyFormat) {
      if (moneyFormatOwner !== window.theme) { moneyFormatOwner = window.theme; originalMoneyFormat = window.theme.moneyFormat; }
      window.theme.moneyFormat = preciseMoneyFormat;
    }
    const cents = Number(lastCartSubtotal);
    if (lastCartSubtotal !== null && lastCartSubtotal !== undefined && lastCartSubtotal !== '' && Number.isSafeInteger(cents) && cents >= 0) {
      const actualSubtotal = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100);
      document.querySelectorAll('.site-header__cart .js-cart-total').forEach(node => { node.textContent = actualSubtotal; });
    }
    document.querySelectorAll('.mini-cart-footer .bottom-total').forEach(label => {
      const node = Array.from(label.childNodes).find(child => child.nodeType === 3 && child.textContent.trim());
      if (node) { if (!subtotalLabels.has(node)) subtotalLabels.set(node, node.textContent); node.textContent = 'Subtotal: '; }
    });
    document.querySelectorAll('[data-kp-sidecart-offer], [data-kp-sidecart-recommendations]').forEach(element => {
      if (element.dataset.kpUtsavReady !== 'true') element.hidden = true;
    });
    document.querySelectorAll('[data-kp-sidecart-hamper-card]').forEach(element => { element.hidden = true; });
    document.querySelectorAll('[data-kp-sidecart-savings] > div:first-child > span:first-child').forEach(node => setHeaderText(node, 'Items before discount'));
    document.querySelectorAll('[data-kp-sidecart-savings] .kp-sidecart-savings__discount > span:first-child').forEach(node => setHeaderText(node, 'Savings'));
  };
  const setHeaderText = (node, value) => {
    if (!node) return;
    if (!headerText.has(node)) headerText.set(node, node.textContent);
    if (node.textContent !== value) node.textContent = value;
  };
  const setHeaderAttribute = (node, name, value) => {
    if (!headerAttributes.has(node)) headerAttributes.set(node, new Map());
    const original = headerAttributes.get(node);
    if (!original.has(name)) original.set(name, node.getAttribute(name));
    node.setAttribute(name, value);
  };
  const refreshHeader = () => {
    if (!isActive()) {
      headerText.forEach((value, node) => { node.textContent = value; });
      headerAttributes.forEach((values, node) => values.forEach((value, name) => {
        if (value === null) node.removeAttribute(name);
        else node.setAttribute(name, value);
      }));
      headerText.clear();
      headerAttributes.clear();
      return;
    }

    const banner = 'Utsav — Save 20% on eligible products worth ₹6,999 or more';
    document.querySelectorAll('.announcement-item__in').forEach(element => {
      Array.from(element.childNodes || []).forEach(node => {
        if (node.nodeType === 3 && /20\s*%/.test(node.textContent || '')
          && /(?:add|choose|pick)\s+(?:any\s+)?3\b/i.test(node.textContent || '')) setHeaderText(node, banner);
      });
    });

    const destination = builderUrl();
    document.querySelectorAll('.section-header a[href], #NavDrawer a[href]').forEach(link => {
      const original = headerAttributes.get(link)?.get('href') ?? link.getAttribute('href');
      let url;
      try { url = new URL(original, window.location.origin); } catch (error) { return; }
      if (url.origin !== window.location.origin || url.username || url.password || url.pathname !== '/pages/combo-page') return;
      setHeaderAttribute(link, 'href', destination);
      if (link.classList.contains('drawer__kinetic-card')) {
        const heading = 'Save 20% on eligible products worth ₹6,999 or more. Choose one piece or mix your favourites.';
        setHeaderText(link.querySelector('.drawer__kinetic-eyebrow'), 'Shop Utsav');
        setHeaderText(link.querySelector('.drawer__kinetic-heading'), heading);
        setHeaderAttribute(link, 'aria-label', `Shop Utsav. ${heading}`);
      } else if (link.classList.contains('site-nav__link')) {
        setHeaderText(link.querySelector('.site-nav__title'), 'Shop Utsav');
      }
    });
  };

  window.KpUtsavJourney = { isActive, isOwnLine, builderUrl, productUrl, observeCart, safeBuilderUrl, resolveEligibleItems, evaluateEligibility, ensureOfferDiscount, hasOfferDiscount: hasOfferAllocations,
    cartRevision: () => cartRevision, isMutating: () => pendingMutations > 0,
    beginMutation: () => { pendingMutations += 1; cartRevision += 1; },
    endMutation: () => { pendingMutations = Math.max(pendingMutations - 1, 0); cartRevision += 1; }
  };
  if (isActive()) {
    try { window.sessionStorage.setItem(storageKey, builderUrl()); } catch (error) { /* URL context survives denied storage. */ }
  }
  document.addEventListener('kp:cart-updated', (event) => { cartRevision += 1; observeCart(event.detail?.cart); });
  document.addEventListener('shopify:section:load', notify);
  window.addEventListener?.('pageshow', notify);
  notify();
})();
